import { render } from "./Journal.vue?vue&type=template&id=6d0f3ab4&scoped=true"
import script from "./Journal.vue?vue&type=script&lang=js"
export * from "./Journal.vue?vue&type=script&lang=js"

import "./Journal.vue?vue&type=style&index=0&id=6d0f3ab4&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0f3ab4"]])

export default __exports__